module.exports = __webpack_public_path__ + "img/fabric-slide-1-l-me.7189397.webp";